<template>
  <div style="background-color: #eee">
    <!--Advertisment card dialogs-->
    <DummyAdvertismentCard ref="dummyAdvDialog"></DummyAdvertismentCard>
    <AdvertismentCardTwo ref="AdvCardTwo"></AdvertismentCardTwo>
    <!--
      Button - A floating create new button 
      Path: components/general/button/
    -->
    <div v-if="isLoggedIn == true">
      <FrontpageCreateArticleButton></FrontpageCreateArticleButton>
    </div>

    <!--If the user is NOT logged in, then this will lie here and be a trigger.  (constant notice that one should log in)-->
    <div v-if="isLoggedIn == false">
      <ConstantLoginReminderCard></ConstantLoginReminderCard>
    </div>

    <!--
      Display tags
      Path: components/general/tabs/
    -->
    <div class="pt-0">
      <v-tabs
        center-active
        grow
        v-if="TagProfiles && TagProfiles.length > 0"
        dark
        v-model="activeProfile"
        color="grey lighten-3"
      >
        <v-tab
          v-for="(profile, n) in TagProfiles"
          :key="profile.id"
          :class="'profile_' + n"
        >
          <span class="title">{{ profile.Name }}</span>
        </v-tab>
        <v-tab class="d-none"></v-tab>
      </v-tabs>
    </div>
    <liveFeed :liveData="liveData" v-if="liveData.length >= 10"></liveFeed>

    <!--Phone, when not logged in-->
    <!-- <div v-if="isLoggedIn == false" class="pt-3">
      <template v-if="$vuetify.breakpoint.xsOnly">
        <PhoneLoginRegisterCard></PhoneLoginRegisterCard>
      </template>
    </div>-->
    <!--Search n Filter-->

    <div style="background-color: #eee" class="pt-3">
      <!--Normal-->
      <v-row v-if="$vuetify.breakpoint.smAndUp">
        <v-spacer></v-spacer>
        <!--Search bar-->
        <v-col md="4" class="ma-0 pa-0 pt-5">
          <v-text-field
            hide-details
            solo
            clearable
            prepend-icon="search"
            v-model="SearchArticles"
            @keyup.enter="createTempProfile"
            @click:clear="SearchArticles = ''"
            @click:prepend="createTempProfile"
            :placeholder="$t('Search')"
          ></v-text-field>
        </v-col>
        <v-col md="auto" class="ml-0 pl-0">
          <!--Menu for geo tagging n such-->
          <div class="text-center">
            <v-menu
              z-index="2"
              v-model="menu"
              attach
              :close-on-content-click="false"
              :close-on-click="false"
              :nudge-width="710"
              offset-x
              left
              nudge-left="-1"
              nudge-bottom="53"
            >
              <template v-slot:activator="{ on }">
                <v-btn icon color="primary" v-on="on" large class="pa-1 mt-1">
                  <v-icon large>fas fa-sort-down</v-icon>
                </v-btn>
              </template>
              <!--Content-->
              <v-card>
                <v-card-text>
                  <!--Geo tags-->
                  <v-col>
                    <v-autocomplete
                      :label="$t('GeoTagging')"
                      v-model="newGeoTags"
                      :items="Geo.SearchTags"
                      :loading="Geo.IsLoading"
                      :search-input.sync="Geo.Search"
                      item-text="Label"
                      item-value="id"
                      autocomplete
                      multiple
                      chips
                      return-object
                      @change="selectedGeoEvent"
                    >
                      <template v-slot:selection="data">
                        <v-chip
                          :input-value="data.selected"
                          close
                          class="chip--select-multi"
                          @click:close="removeGeoTag(data.item)"
                          @input="removeGeoTag(data.item)"
                          >#{{ data.item.Label }}</v-chip
                        >
                      </template>
                      <template v-slot:item="data">
                        <v-row align-start justify-space-around row fill-height>
                          <v-col>
                            <div class="headline">#{{ data.item.Label }}</div>
                          </v-col>
                        </v-row>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <!--Interest Tags-->
                  <v-col>
                    <v-autocomplete
                      :label="$t('Tagging')"
                      v-model="newTags"
                      :items="TagsOrdered"
                      :loading="Tag.IsLoading"
                      :search-input.sync="Tag.Search"
                      item-text="Label"
                      item-value="id"
                      autocomplete
                      multiple
                      chips
                      return-object
                      @change="selectedTagEvent"
                    >
                      <template v-slot:selection="data">
                        <v-chip
                          :selected="data.selected"
                          close
                          class="chip--select-multi"
                          @click:close="removeTag(data.item)"
                          @input="removeTag(data.item)"
                          >#{{ data.item.Label }}</v-chip
                        >
                      </template>
                      <template v-slot:item="data">
                        <v-row align-start justify-space-around row fill-height>
                          <v-col>
                            <div class="headline">#{{ data.item.Label }}</div>
                          </v-col>
                        </v-row>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <!--Search Button-->
                  <v-col class="text-end">
                    <v-btn
                      @click="createTempProfile"
                      v-text="$t('Search for articles')"
                    ></v-btn>
                  </v-col>
                </v-card-text>
              </v-card>
            </v-menu>
          </div>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <!--Search n filter desktop end-->

      <!--Phone search and filter-->
      <v-row v-else class="ma-0 pa-0">
        <v-col class="ma-0 pa-0 pt-5 pl-3">
          <v-text-field
            hide-details
            solo
            clearable
            v-model="SearchArticles"
            @keyup.enter="createTempProfile"
            @click:clear="createTempProfile"
            @click:prepend="createTempProfile"
            :placeholder="$t('Search')"
          ></v-text-field>
        </v-col>
        <v-col cols="auto">
          <v-menu
            v-model="menu"
            z-index="2"
            :close-on-content-click="false"
            :close-on-click="false"
            :nudge-width="710"
            offset-x
            left
            nudge-left="5"
            nudge-bottom="55"
          >
            <template v-slot:activator="{ on }">
              <v-btn icon color="primary" v-on="on" large class="pa-1 mt-1">
                <v-icon large>fas fa-sort-down</v-icon>
              </v-btn>
            </template>
            <!--Filter dropdown-->
            <v-card>
              <v-card-text>
                <!--Geo tags-->
                <v-col>
                  <v-autocomplete
                    :label="$t('GeoTagging')"
                    v-model="newGeoTags"
                    :items="Geo.SearchTags"
                    :loading="Geo.IsLoading"
                    :search-input.sync="Geo.Search"
                    item-text="Label"
                    item-value="id"
                    autocomplete
                    multiple
                    chips
                    return-object
                    @change="selectedGeoEvent"
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        :input-value="data.selected"
                        close
                        class="chip--select-multi"
                        @click:close="removeGeoTag(data.item)"
                        @input="removeGeoTag(data.item)"
                        >#{{ data.item.Label }}</v-chip
                      >
                    </template>
                    <template v-slot:item="data">
                      <v-row align-start justify-space-around row fill-height>
                        <v-col>
                          <div class="headline">#{{ data.item.Label }}</div>
                        </v-col>
                      </v-row>
                    </template>
                  </v-autocomplete>
                </v-col>
                <!--Interest Tags-->
                <v-col>
                  <v-autocomplete
                    :label="$t('Tagging')"
                    v-model="newTags"
                    :items="TagsOrdered"
                    :loading="Tag.IsLoading"
                    :search-input.sync="Tag.Search"
                    item-text="Label"
                    item-value="id"
                    autocomplete
                    multiple
                    chips
                    return-object
                    @change="selectedTagEvent"
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        :selected="data.selected"
                        close
                        class="chip--select-multi"
                        @click:close="removeTag(data.item)"
                        @input="removeTag(data.item)"
                        >#{{ data.item.Label }}</v-chip
                      >
                    </template>
                    <template v-slot:item="data">
                      <v-row align-start justify-space-around row fill-height>
                        <v-col>
                          <div class="headline">#{{ data.item.Label }}</div>
                        </v-col>
                      </v-row>
                    </template>
                  </v-autocomplete>
                </v-col>
                <!--Search Button-->
                <v-col class="text-end">
                  <v-btn
                    @click="createTempProfile"
                    v-text="$t('Apply form')"
                  ></v-btn>
                </v-col>
              </v-card-text>
            </v-card>
          </v-menu>
        </v-col>
      </v-row>
    </div>

    <!--Render in article on click (dialog)-->
    <v-dialog
      v-model="viewarticle"
      max-width="1000"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <!--If Finding the article data - open and display article-->
      <article-component
        v-if="Article.id"
        :articledata="Article"
        @updatearticle="setArticle()"
      ></article-component>
      <!--ELSE Not finding the article data, display a loader (skeleton - loader) -->
      <v-sheet v-else color="grey " class="px-3 pt-3 pb-3">
        <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
      </v-sheet>
    </v-dialog>

    <!--Display progress - when getting articles-->
    <v-dialog v-model="waitForServerResponse" fullscreen>
      <v-container fluid fill-height style="background-color: rgba(0,0,0,0.5)">
        <v-row align-center justify-center>
          <v-col xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-toolbar center dark color="primary">
                <v-spacer />
                <v-toolbar-title v-text="waitForServerResponseMsg">
                  <v-progress-circular indeterminate class="ml-2" />
                </v-toolbar-title>
                <v-spacer />
              </v-toolbar>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-dialog>

    <!--
      Top articles when the user enters the website
    -->
    <MainArticles
      :news="mainArticles"
      v-if="mainArticles.length > 0"
    ></MainArticles>
    <!--
      Main Articles
    -->
    <div style="background-color: #eee">
      <v-container grid-list-xs>
        <MostRecent
          :news="mostRecent"
          v-if="mostRecent.length == 15"
        ></MostRecent>
        <techNews></techNews>
        <cultureNews></cultureNews>
        <remainingNews ref="remaining"></remainingNews>
        <!--Displayed when loading next set of articles-->
        <v-row v-if="lazyloading">
          <v-col md="12">
            <v-sheet color="grey" class="px-3 pt-3 pb-3">
              <v-skeleton-loader type="card">
                {{ $t("Please wait while we are gathering data") }}
                <v-progress-circular
                  indeterminate
                  color="green"
                  :size="70"
                  :width="7"
                ></v-progress-circular>
              </v-skeleton-loader>
            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
// General components
import FrontpageCreateArticleButton from "./components/general/button/FrontpageCreateArticleButton";
import ConstantLoginReminderCard from "./components/general/card/ConstantLoginReminderCard";
import SignInPersonalistCard from "./components/cards/SignInPersonalistCard";
// Desktop specific components
import RandomFeed from "./components/desktop/randomFeed/randomFeed.vue";
// Phone specific components
import PhoneLoginRegisterCard from "./components/general/card/PhoneLoginRegisterCard";
// Sort
import AdvertismentCards from "./components/advertismentCards/advertismentCards.vue";
import articleComponentTwo from "./components/article_v2";
import AdvertismentCardTwo from "@/components/dialogs/AdvertismentCardTwo.vue";
import DummyAdvertismentCard from "@/components/dialogs/dummyAdvertismentCard.vue";
import headerModuleDivider from "./components/headermoduledivider";
import headerModuleUserNav from "./components/headermoduleusernav";
import articleComponent from "./components/article";
import liveFeed from "./components/microServices/liveFeed";
import MostRecent from "./components/microServices/mostRecent";
import MainArticles from "./components/microServices/mainArticles";
import techNews from "./components/microServices/techNews";
import cultureNews from "./components/microServices/cultureNews";
import remainingNews from "./components/microServices/remainingArticles";

import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import { mapGetters, mapActions } from "vuex";
import messages from "./modules/lang/main/export";
export default {
  i18n: { messages },
  components: {
    AdvertismentCards,
    articleComponentTwo,
    AdvertismentCardTwo,
    DummyAdvertismentCard,
    headerModuleDivider,
    headerModuleUserNav,
    articleComponent,
    VueperSlides,
    VueperSlide,
    FrontpageCreateArticleButton,
    RandomFeed,
    ConstantLoginReminderCard,
    SignInPersonalistCard,
    PhoneLoginRegisterCard,
    liveFeed,
    techNews,
    remainingNews,
    MostRecent,
    MainArticles,
    cultureNews,
  },
  data() {
    return {
      sizeRSS: 8,
      fromRSS: 0,
      articlesRetrieved: false,
      size: 19,
      from: 0,

      lazyloading: false,
      lazyloadingtimer: 0,
      lazyloadingbuffer: 0,

      menu: false,
      viewarticle: false,
      filterDialog: false,
      Article: {
        id: null,
        currentLanguage: "",
        Created: null,
        Updated: null,
        Category: "",
        ArticleType: "",
        Comments: false,
        OrgLanguage: "",
        Pages_id: "",
        Subscription_id: null,
        Users_id: null,
        Content: [],
        Media: [],
        Tags: [],
        GeoTags: [],
      },
      mounted: false,
      SERVERADRESS: process.env.VUE_APP_BASEAPI,
      waitForServerResponse: false,
      waitForServerResponseMsg: this.$t("Please wait..."),
      activeProfile: localStorage.getItem("activeProfile") || 0,
      articleTimeout: null,
      articlenaTimeout: null,
      currentGeo: [],
      currentTag: [],
      Articles: [], //Stores regular articles from api response
      ArticlesFeed: [], //
      SearchArticles: "",
      newGeoTags: localStorage.getItem("geotags")
        ? JSON.parse(localStorage.getItem("geotags"))
        : [],
      Geo: {
        SearchTags: localStorage.getItem("geotags_searchitems")
          ? JSON.parse(localStorage.getItem("geotags_searchitems"))
          : [],
        SearchTimeout: null,
        IsLoading: false,
        Search: "",
      },
      newTags: localStorage.getItem("tags")
        ? JSON.parse(localStorage.getItem("tags"))
        : [],
      Tag: {
        SearchTags: [],
        SearchTimeout: null,
        IsLoading: false,
        Search: "",
      },
      TechArticles: [],
      mostRecent: [], //top 5 recent rss, user and tweets
      liveData: [], //MOST recent rss and twitter news,
      mainArticles: [],
    };
  },
  // beforeMount(){
  //   this.pickRandomAdvertisment()
  // },
  watch: {
    getLang(newLocale) {},
    $route(newVal) {
      if (newVal.params.articleid) {
        this.setArticle(newVal.params.articleid);
      } else if (this.viewarticle) {
        this.viewarticle = false;
      }
    },
    viewarticle(visible) {
      if (visible === false) {
        // remove front/XX
        this.$router.replace({ name: "frontpage", params: {} });
      }
    },
    activeProfile(newVal, oldVal) {
      if (newVal !== this.TagProfiles.length) {
        this.newTags = [];
        this.newGeoTags = [];
        this.SearchArticles = "";
        localStorage.setItem("activeProfile", newVal);
        this.updateTagList();
      }
    },
    "Geo.Search"(newVal) {
      // if (this.Geo.IsLoading) return;
      this.Geo.IsLoading = true;
      clearTimeout(this.Geo.SearchTimeout);
      this.Geo.SearchTimeout = setTimeout(() => {
        this.SEARCH_GEO_SUGGESTION(newVal)
          .then((resp) => {
            this.Geo.SearchTags = resp.data.concat(this.newGeoTags);
          })
          .catch((ex) => console.log(ex))
          .finally(() => {
            this.Geo.IsLoading = false;
          });
      }, 200);
    },
  },
  computed: {
    ...mapGetters([
      "isLoggedIn",
      "authStatus",
      "TagProfiles",
      "getTags",
      "userId",
      "getLang",
      "getRemainingNews",
    ]),
    firstTagProfile() {
      if (this.TagProfiles && this.TagProfiles.length > 0) {
        return this.TagProfiles[0];
      } else {
        return null;
      }
    },
    otherTagProfiles() {
      if (this.TagProfiles && this.TagProfiles.length > 1) {
        return this.TagProfiles.slice(1);
      } else {
        return null;
      }
    },
    TagsOrdered() {
      let _Tags = this.getTags;
      if (_Tags && _Tags.length > 0) {
        return _Tags.map((tag) => {
          return {
            ...tag,
            Label: tag.TranslatedLabel ? tag.TranslatedLabel : tag.Label,
          };
        });
      } else {
        return [];
      }
    },
    LatestArticles() {
      return this.Articles;
      // .filter(res => res.ArticleType == "article");
    },
    Latest_nav_opprettelse_foretak() {
      return this.Articles.filter(
        (res) => res.ArticleType == "nav_opprettelse_foretak"
      );
    },
    Latest_nav_ledige_stillinger() {
      return this.Articles.filter(
        (res) => res.ArticleType == "nav_ledige_stillinger"
      );
    },
  },

  // Calls from vuex
  methods: {
    ...mapActions([
      "GET_FRONTPAGE",
      "SEARCH_GEO_SUGGESTION",
      "GET_PUBLIC_ARTICLE",
      "GET_FRONTPAGENA",
    ]),
    // Scroll feature
    scroll() {
      window.onscroll = () => {
        if (this.lazyloading) return;
        let bottomOfWindow =
          document.documentElement.scrollTop + window.innerHeight >
          document.documentElement.offsetHeight - 100;
        if (bottomOfWindow && this.$refs.remaining.returnLengthOfBuffer() > 0) {
          this.lazyloading = true;
          clearTimeout(this.lazyloadingtimer);
          this.lazyloadingtimer = setTimeout(() => {
            this.getNextSet()
              .then(() => {
                this.lazyloading = false;
              })
              .catch(() => {
                this.lazyloading = false;
              });
          }, 300);
        }
      };
    },

    /*
      In the HTML we run a slice through the index, to define which articles we wanna display.
      This will go by the start index up to (not included) the last index.
        0,4 (articles from index 0 to 4 =  0, 1, 2, 3),
        4,8 (articles from index 4 to 8  = 4, 5, 6, 7)

      It looks like this.
        <template v-for="(articlefeed) in ArticlesFeed.slice(getArrayFeedIndex(index), getArrayFeedIndex(index + 8) )">

      (getArrayFeedIndex(index))   = Start of the index
      , getArrayFeedIndex(index + 8) = Up to this index



      ArticleIndex = Current index of the articles. (8, 16, 24, 32, 40 ...)
      CurrentIndex = ArticleIndex / 8  = (1, 2, 3, 4, 5 ....)

      Lastly we take the currentIndex and multiply it with 4.

      (currentIndex * 4)     = 1*4, 2*4, 3*4, 4*4, 5*4    (4, 8. 12. 16. 20)

      Then to finish it up, we subsrtact 4
      4-4, 8-4, 12-4, 16-4, 20-4  (0, 4, 8, 12, 16)

      This we use to decide the starting point of the articles within the array.

    */
    getArrayFeedIndex(ArticleIndex) {
      let currentIndex = Math.floor(ArticleIndex / 8);
      return currentIndex * 4 - 4;
    },

    getNewsBlocks(Articles) {
      //Define which news block articles belongs to
      //Some blocks may have zero or only few articles, so if an article has
      //two tags (one popular, one with few), prioritize the few one so we
      //can fill it up as much as possible

      if (Articles.length == 0 || !Articles[0].metadata) {
        return false;
      }

      if (Articles.length) {
        let blocks = {
          Technology: [],
          Politics: [],
          Business: [],
          Entertainment: [],
          Food: [],
          Culture: [],
          Sport: [],
          Lifestyle: [],
        };
        for (const el of Articles) {
          let _meta = el.metadata
            .replace(/: u'/gm, ": '")
            .replace(/"/g, "'")
            .replace(/'/g, '"'); //change quotes before JSON parsing
          _meta = JSON.parse(_meta);
          el.metadata = _meta;
          //Unique categories in this article
          let _categories = [...new Set(_meta.metatags.map((x) => x.category))];
          if (_categories.length > 0) {
            //An article can contain mulitple categories, so we insert it into
            //the one with least content in order to balance their amounts
            let _leastBlock = _categories[0];
            _categories.slice(1, _categories.length).forEach((cat) => {
              if (blocks[cat].length < blocks[_leastBlock].length) {
                _leastBlock = cat;
              }
            });
            blocks[_leastBlock].push(el);
          }
        }
        return blocks;
      } else {
        return false;
      }
    },

    getMostRecent(articles, rss) {
      //Return 5 most recent tweets, rss and user content
      articles = articles.sort((a, b) => a.Updated - b.Updated);
      rss = rss.sort((a, b) => a.Updated - b.Updated);

      let _user = articles.slice(0, 5);
      let _twitter = [];
      let _rss = [];

      for (const el of rss) {
        if (el.ArticleType == "rss_article" && _rss.length < 5) {
          _rss.push(el);
        } else if (el.ArticleType == "twitter" && _twitter.length < 5) {
          _twitter.push(el);
        }
      }
      return [_user, [..._twitter, ..._rss]];
    },

    getMainArticles(articles) {
      /*
        - mainCard should have image and be new and popular (views, comments)
        - sideCards are two other articles with image that should be somewhat popular too
      */
      let mainCard = false;
      let sideCards = [];

      //Just a quick way that populates purely based on views
      for (const el of articles) {
        if (el.MediaData.length > 0) {
          //Contains image
          if (mainCard == false) {
            mainCard = el;
          } else if (sideCards.length < 2) {
            sideCards.push(el);
          } else {
            break;
          }
          //  else if (el.Views > mainCard.Views) {
          //   mainCard = el;
          // } else {
          //   if (sideCards[0].Views < el.Views) {
          //     sideCards[0] = el;
          //   } else if (sideCards[1].Views < el.Views) {
          //     sideCards[1] = el;
          //   }
          // }
        }
      }
      if (mainCard == false) {
        return [];
      } else {
        return [mainCard, ...sideCards];
      }
    },

    categorizeArticles() {
      /*
      This function takes all available articles and rss/twitter etc. data and places them into
      different sections of the page.
      The logic is to find which one to put where, and then remove them from the list so the
      next module wont use the same article (duplicates)
      Insert remaining articles into an own module in the end
      */
      let _articles = this.Articles;
      let _rss = this.ArticlesFeed; //Everything thats NOT regular article
      //Empty global data (these are split up and sent to components which handles them)
      this.ArticlesFeed = [];
      this.Articles = [];

      //15 MOST recent rss and tweets
      this.liveData = _rss.slice(0, 15);
      _rss = _rss.slice(15, _rss.length); //Remove the ones we added for liveData

      //Main articles to display on top of the page (Only 50 newest are considered)
      // let main = this.getMainArticles(_articles.slice(0, 50));
      let main = this.getMainArticles(_articles.slice(0, 50));
      if (main.length == 3) {
        this.mainArticles = main;
        //Remove articles we added
        let _rem = main.map((x) => x.id);
        _articles = _articles.filter(function(obj) {
          return !_rem.includes(obj.id);
        });
      } else {
        this.mainArticles = [];
      }

      //Get top 5 recent tweet, rss and user content
      let mostRecent = this.getMostRecent(_articles, _rss); //[0] = user, [1] = twitter&rss
      if (mostRecent[0].length + mostRecent[1].length == 15) {
        this.mostRecent = [...mostRecent[0], ...mostRecent[1]];
        //Remove based on IDs
        let _userRem = mostRecent[0].map((x) => x.id);
        let _rssRem = mostRecent[1].map((x) => x.Articles_id);
        _articles = _articles.filter(function(obj) {
          return !_userRem.includes(obj.id);
        });
        _rss = _rss.filter(function(obj) {
          return !_rssRem.includes(obj.Articles_id);
        });
      } else {
        this.mostRecent = [];
      }

      //Which articles belongs to which news blocks
      let blocks = this.getNewsBlocks(_articles);
      if (blocks != false) {
        //Only create these blocks for default frontpage as of now
        //Create technology and culture blocks (more are available to be created)
        if (blocks.Technology.length > 10) {
          let tech = blocks.Technology.slice(0, 20); //Send max 20 to this block
          let _rem = tech.map((x) => x.id);
          _articles = _articles.filter(function(obj) {
            return !_rem.includes(obj.id);
          });
          this.$store.commit("insertTechNews", { articles: tech });
        }
        if (blocks.Culture.length > 10) {
          let culture = blocks.Culture.slice(0, 20); //Send max 20 to this block
          let _rem = culture.map((x) => x.id);
          _articles = _articles.filter(function(obj) {
            return !_rem.includes(obj.id);
          });
          this.$store.commit("insertCultureNews", { articles: culture });
        }
      } else {
        //Empty blocks (Not visible on frontpage)
        this.$store.commit("insertCultureNews", { articles: [] });
        this.$store.commit("insertTechNews", { articles: [] });
      }

      //Remaining articles will be displayed in a standard way
      this.$store.commit("insertRemainingNews", {
        articles: _articles,
      });
    },

    // Get all the articles
    getArticles() {
      return new Promise((resolve, reject) => {
        this.articlesRetrieved = false;
        if (this.Articles.length > 0) this.waitForServerResponse = true;
        this.waitForServerResponseMsg = this.$t(
          "Sorting articles, please wait.."
        );
        clearTimeout(this.articleTimeout);
        this.articleTimeout = setTimeout(() => {
          this.GET_FRONTPAGE({
            isLoggedIn: this.isLoggedIn,
            size: this.size, //Decides article order
            from: this.from,
            test: "hello",
            GeoTags: this.currentGeo,
            Tags: this.currentTag,
            Lang:
              localStorage.getItem("setlanguage") ||
              localStorage.getItem("detectedlanguage") ||
              "en",
            Search:
              this.activeProfile === this.TagProfiles.length
                ? this.SearchArticles
                : "",
          })
            .then((resp) => {
              this.articlesRetrieved = true;
              this.Articles = resp.data;
            })
            .catch((ex) => {
              this.Articles = [];
              console.error(ex);
            })
            .finally(() => {
              this.waitForServerResponse = false;
              resolve(true);
            });
        }, 200);
      });
    },

    // Getting next set of articles, when scrolling
    getNextSet() {
      return new Promise((resolve, reject) => {
        //Trigger buffer loading in the remaining component
        this.$refs.remaining
          .loadBufferedArticles()
          .then(() => resolve())
          .catch((ex) => {
            reject();
          });
      });
    },

    // Get articles from other sources - NRK, NAV, Brønnøysund or Twitter
    getArticlesFromFeed() {
      // Run a Promise
      return new Promise((resolve, reject) => {
        let _Lang =
          localStorage.getItem("setlanguage") ||
          localStorage.getItem("detectedlanguage") ||
          "en";

        //Tmp fix, dont call for other articles if not nb or bg
        if (_Lang != "nb" && _Lang != "bg") {
          resolve(true);
        }
        // If the lenght of the Articles isnt bigger than 0, then wait for an response is true
        if (this.ArticlesFeed.length > 0) this.waitForServerResponse = true;
        // If we are waiting, then this is the message that will be displayed
        this.waitForServerResponseMsg = this.$t(
          "Sorting articles, please wait.."
        );
        // ???
        clearTimeout(this.articlenaTimeout);
        // ???
        this.articlenaTimeout = setTimeout(() => {
          // Run the get call from store.js - getting all the feed articles
          this.GET_FRONTPAGENA({
            size: this.sizeRSS,
            from: this.fromRSS,
            isLoggedIn: this.isLoggedIn,
            // ???
            GeoTags: this.currentGeo,
            // ???
            Tags: this.currentTag,
            // ???
            Lang:
              localStorage.getItem("setlanguage") ||
              localStorage.getItem("detectedlanguage") ||
              "en",
            Search:
              this.activeProfile === this.TagProfiles.length
                ? this.SearchArticles
                : "",
            // The response of the function above
          })
            .then(async (resp) => {
              // Article feed array are filled with the response data
              let _data = resp.data;
              for (var i = 0; i < _data.length; i++) {
                let _currentArticle = _data[i];
                switch (_currentArticle.ArticleType) {
                  case "twitter":
                    _currentArticle.MediaData = [
                      {
                        s3url:
                          "https://wenewz.s3.eu-north-1.amazonaws.com/public/png-twitter-logo-twitter-in-png-2500.png",
                      },
                    ];

                    break;
                  case "nav_opprettelse_foretak":
                  case "nav_ledige_stillinger":
                    _currentArticle.MediaData = [
                      { s3url: "/Rod NAV_logo_CMYK.png" },
                    ];
                    break;
                  case "Brreg_opprettelse_foretak":
                    _currentArticle.MediaData = [{ s3url: "/bronnoysund.jpg" }];
                    break;
                  default:
                }
              }
              // await _data.sort((a, b) => parseInt(a.Score) - parseInt(b.Score)); //Sort by score
              this.ArticlesFeed = resp.data;
            })
            .catch((ex) => {
              console.error(ex);
            })
            .finally(() => {
              this.waitForServerResponse = false;
              resolve(true);
            });
          // Timeout?
        });
      });
    },

    async updateTagList() {
      if (this.activeProfile === this.TagProfiles.length) {
        this.currentGeo = (await this.newGeoTags.map((res) => res.id)) || [];
        this.currentTag = (await this.newTags.map((res) => res.id)) || [];

        if (this.mounted === true) {
          Promise.all([this.getArticles(), this.getArticlesFromFeed()]).then(
            () => {
              this.scroll();
              this.categorizeArticles(); //Divide into tech news, politics etc
            }
          );
        }
      } else {
        if (this.TagProfiles && this.TagProfiles.length > 0) {
          let _index = 0;
          if (this.TagProfiles.hasOwnProperty(this.activeProfile)) {
            _index = this.activeProfile;
          } else {
            this.activeProfile = _index;
          }

          //Update geo and interest then fetch from API
          this.currentGeo =
            (await (
              this.TagProfiles[_index] && this.TagProfiles[_index]["GeoTags"]
            ).map((res) => res.id)) || [];
          this.currentTag =
            (await (
              this.TagProfiles[_index] && this.TagProfiles[_index]["Tags"]
            ).map((res) => res.id)) || [];

          //This is so we dont run getArticles twice when mounting
          if (this.mounted === true) {
            Promise.all([this.getArticles(), this.getArticlesFromFeed()]).then(
              () => {
                this.scroll();
                this.categorizeArticles(); //Divide into tech news, politics etc
              }
            );
          }
        } else {
          setTimeout(this.updateTagList, 200);
        }
      }
    },
    removeGeoTag(item) {
      this.newGeoTags = this.newGeoTags.filter((geo) => geo.id != item.id);
    },
    removeTag(item) {
      this.newTags = this.newTags.filter((geo) => geo.id != item.id);
    },
    selectedGeoEvent(evt) {
      this.Geo.Search = "";
    },
    selectedTagEvent(evt) {
      this.Tag.Search = "";
    },
    createTempProfile(evt) {
      this.menu = false;
      if (
        this.newGeoTags.length == 0 &&
        this.newTags.length == 0 &&
        this.SearchArticles == ""
      ) {
        return false;
      }
      localStorage.setItem("geotags", JSON.stringify(this.newGeoTags));
      localStorage.setItem(
        "geotags_searchitems",
        JSON.stringify(this.Geo.SearchTags)
      );
      localStorage.setItem("tags", JSON.stringify(this.newTags));
      this.activeProfile = this.TagProfiles.length;
      this.Articles = [];
      localStorage.setItem("activeProfile", this.activeProfile);

      this.updateTagList();
      // Delete the one not in use, del if nr 2
      this.filterDialog = false;
    },
    resetArticle() {
      this.Article.id = null;
      this.Article.currentLanguage = "";
      this.Article.Created = null;
      this.Article.Updated = null;
      this.Article.Category = "";
      this.Article.ArticleType = "";
      this.Article.Comments = false;
      this.Article.OrgLanguage = "";
      this.Article.Pages_id = "";
      this.Article.Subscription_id = null;
      this.Article.Users_id = null;
      this.Article.Content = [];
      this.Article.Media = [];
      this.Article.Tags = [];
      this.Article.GeoTags = [];
    },
    setArticle(id) {
      if (!id && this.Article.id) id = this.Article.id;
      this.viewarticle = true;
      this.resetArticle();
      this.GET_PUBLIC_ARTICLE(id).then((resp) => {
        const regex = /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/gim;

        resp.data.Content.forEach((content) => {
          if (resp.data.ArticleType == "article") {
            content.Content = content.Content.replace(regex, (match) => {
              return `<a href="${match}" target="_blank">${decodeURIComponent(
                match
              )}</a>`;
            });
            content.Content = content.Content.replace(
              /(?:\r\n|\r|\n)/g,
              "<br>"
            );
          }
        });
        this.Article = resp.data;
      });
    },
    // ????
    setArticleFeed(id) {
      // To see that it is running
      // ???
      if (!id && this.Article.id) id = this.Article.id;
      // ???? - Look up
      this.viewarticle = true;
      // ???
      this.resetArticle();
      // ???
      this.GET_PUBLIC_ARTICLE(id).then((response) => {
        // ???
        const regex = /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/gim;
        // ???
        response.data.Content.forEach((content) => {
          // ???
          content.Content = content.Content.replace(regex, (match) => {
            // ???
            return `<a href="${match}" target="_blank">${decodeURIComponent(
              match
            )}</a>`;
          });
          // ???
          content.Content = content.Content.replace(/(?:\r\n|\r|\n)/g, "<br>");
        });
        // ????
        this.Article = response.data;
      });
    },
  },

  mounted() {
    // console.log("Mounted");
    // Promise.all([this.getArticles(), this.getArticlesFromFeed()]).then(() => {
    this.getArticles().then(() => {
      // console.log("Inserted mount");
      this.scroll();
      this.categorizeArticles(); //Divide into tech news, politics etc
      this.mounted = true;
      if (this.$route.params && this.$route.params.articleid) {
        this.setArticle(this.$route.params.articleid);
      }
    });
  },
};

function compareCreatedFunction(a, b) {
  let Property = "Created";
  if (a[Property] < b[Property]) return -1;
  if (a[Property] > b[Property]) return 1;
  return 0;
}
</script>

<style scoped>
/*Deep css, to remove img tag from v-html print from RSS data*/
.removeImg >>> img,
.removeImg >>> br {
  display: none;
}

.expandCard {
  transition: all 1s;
  /* transition-timing: ease-in-out; */
}
.expandCard:hover {
  transition: 0.5s;
  transform: scale(1.03);
}

.moduleheader {
  font-size: 2em;
  font-weight: 400;
  position: relative;
}
/* .moduleheader:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -24px;
  border-bottom: 2px solid #cc0000;
  width: 50px;
} */
.redborderbottom {
  border-bottom: 2px solid #cc0000 !important;
}
.greenborderbottom {
  border-bottom: 2px solid #065313 !important;
}
.topbar-container {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-content: stretch;
  align-items: flex-start;
}
.topbar-container > * {
  width: 100%;
  margin-bottom: 20px;
}

.topbar-container .left {
  order: 0;
  flex: 0 1 auto;
  align-self: auto;
  text-align: left;
}

.topbar-container .center {
  order: 0;
  flex: 0 2 auto;
  align-self: auto;
}
.topbar-container .center img {
  width: 150px;
}

.topbar-container .right {
  margin: 15px;
  order: 0;
  flex: 0 1 auto;
  align-self: auto;
  text-align: right;
}
.topbar-container .right a,
a.articlelinks {
  text-decoration: none;
  color: black;
}
.topbar-container .right a:hover,
a.articlelinks:hover {
  text-decoration: underline;
}
.topbar-menu-container {
  border-bottom: 4px solid black;
  padding-bottom: 20px;
}
.topbar-menu-container .flex {
  text-align: center;
  font-size: 1.2em;
}

.topbar-breakingnews {
  margin-top: 20px;
  border: 4px solid #000000;
  background-color: #000000;
}
.breakingnews.label {
  background-color: #000000;
  color: #ffffff;
  padding: 0 10px;
  position: relative;
}
.breakingnews.flashcolorred {
  animation: labelFlash linear 2s infinite;
}
@keyframes labelFlash {
  0% {
    color: #ffffff;
  }
  20% {
    color: #cc0000;
  }
  60% {
    color: #ffffff;
  }
  100% {
    color: #ffffff;
  }
}
/* .breakingnews.label:before {
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;

  color: #cc0000;
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  content: "\f111";
  position: absolute;
  left: 4px;
  border-radius: 50%;
  border: 2px solid red;
  width: 23px;
} */

.breakingnews.redcircle {
  display: inline-block;
  /* background-color: #cc0000; */
  border: 1px solid black;
  border-color: #000000;
  border-style: solid;

  box-shadow: 0 0 0 2px #dd0000;
  height: 10px;
  width: 10px;

  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  margin-right: 5px;
  position: relative;
  /* top:2px; */
  left: 5px;
  animation: circularshadowrotate linear 1s infinite;
}

@keyframes circularshadowrotate {
  0% {
    box-shadow: 0 0 0 2px #dd0000;
  }
  25% {
    box-shadow: 2px 0 0 2px #dd0000;
  }
  50% {
    box-shadow: 2px 2px 0 2px #dd0000;
  }
  75% {
    box-shadow: 0 2px 0 2px #dd0000;
  }
  100% {
    box-shadow: 0 0 0 2px #dd0000;
  }
}
.breakingnews.blackarrow {
  display: inline-block;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 3.5px 0 3.5px 7px;
  border-color: transparent transparent transparent #000000;
}
.breakingnews.content {
  padding-left: 20px;
  width: 100%;
}
.breakingnews.whitearrow {
  display: inline-block;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 3.5px 0 3.5px 7px;
  border-color: transparent transparent transparent #ffffff;
}
.breakingnews.readmore {
  background-color: #000000;
  color: #ffffff;
  padding: 1px 20px;
}

.greybottomborder {
  border-bottom: 2px solid #aeaeae !important;
}
</style>

<style>
.frontpageslideshow1 .vueperslides__bullets {
  left: auto;
  width: 30px;
  /* height: 50%; */
  bottom: 30px;
  right: 30px;
  flex-direction: column;
  justify-content: center;
  /* align-content: flex-end; */
  align-items: center;
  /* background-color: rgba(0,0,0,0.1); */
  z-index: 10;
}
.frontpageslideshow1 a {
  text-decoration: none;
  color: inherit;
}
.frontpageslideshow1 {
  color: white;
  text-shadow: -2px 0 black, 0 2px black, 2px 0 black, 0 -2px black;
}
.frontpageslideshow1 .vueperslides__bullet {
  background-color: rgba(0, 0, 0, 0);
  border: 1px solid rgba(255, 255, 255, 0.4);
  box-shadow: none;
  transition: 0.3s;
  width: 10px;
  height: 10px;
  margin: 4px 0;
}

/* .frontpageslideshow1 .vueperslides__bullet--active {
  background-color: #cc0000;
  border: 1px solid #cc0000;
} */

.frontpageslideshow1 .vueperslides__bullet span {
  display: none;
}
.profile_0 {
  background: white !important;
  color: black !important;
}
</style>
